import React, { Component } from 'react';

class Contact extends Component {

    render() {
        return (
            <>
            <div className="skills container my-5 text-center" id="contact">
                <div className="card">
                    <h4 className="text-muted text-center">Contact Me</h4>
                    <hr/>
                    <p>Email: danielobare551@gmail.com</p>
                    <p>Phone Number: 0725816679</p>
                    <div className="d-inline-block my-2">
                    <a href="tel:0725816679" className="btn btn-dark">Call</a>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default Contact;